import {store} from "../store";
import appConfig from "../appconfig";
import * as mutationTypes from "../store/mutation-types";
import GroupOrderProvider from "../providers/GroupOrderProvider";

export default {
	startGroupOrderPolling: async function() {
		const {groupOrderId, isUserGroupOrderOwner} = store.getters;
		if (groupOrderId && isUserGroupOrderOwner) {
			await updateOrderLines();
			const id = setInterval(async () => {
				await updateOrderLines();
			}, 5000);
			return id;
		}
	},
	stopGroupOrderPolling: function(timerId) {
		clearInterval(timerId);
	},
	prepareProductSelections: function() {
		const {isUserGroupOrderOwner} = store.getters;
		isUserGroupOrderOwner && store.commit(mutationTypes.FILTER_ONLY_OWNERS_PRODUCT_SELECTIONS);
	},
	createGroupOrder: async function(shopId, deliveryChoiceId) {
		const {applicationUserIdpToken} = store.getters;
		const result = await GroupOrderProvider.create({idpToken: applicationUserIdpToken, tenantId: appConfig.tenantId, shopId, deliveryMethod: deliveryChoiceId});
		store.commit(mutationTypes.SET_GROUP_ORDER, result.id);
		store.commit(mutationTypes.GROUP_ORDER_IS_USER_OWNER, true);
		return result;
	},
	sendProductSelections: async function(vueObject, cartProducts) {
		const userData = store.getters.getUserData;
		const personData = store.getters.personData || {};
		const {groupOrderId} = store.getters;
		GroupOrderProvider.sendProductSelections(
			groupOrderId,
			cartProducts,
			{
				name: userData ? userData.name : `${personData.firstName} ${personData.lastName}`,
				email: userData && userData.email
			},
			appConfig.tenantId,
			store
		).then((data) => {
			if(data) {
				store.dispatch(mutationTypes.CART_EMPTY_ALL);
				setTimeout(() => store.commit(
					mutationTypes.SET_GLOBAL_INFO_DIALOG,
					"shopComponents.gt2.shoppingCart.groupOrder.orderSuccessfullySent"
				), 300);
				setTimeout(() => vueObject.$router.push("/"), 3000);
			}
		});
	},
	cancelGroupOrder: function() {
		const {isUserGroupOrderOwner} = store.getters;
		if (isUserGroupOrderOwner) {
			const {groupOrderId, applicationUserIdpToken} = store.getters;
			GroupOrderProvider.cancelGroupOrder(
				applicationUserIdpToken,
				groupOrderId,
				appConfig.tenantId,
				store
			).then(() => {
				store.commit(mutationTypes.RESET_GROUP_ORDER_STATE);
			});
		}
	},
	removeFriendOrder: async function(orderItemIdToRemove) {
		const {applicationUserIdpToken, groupOrderId, groupOrderFriendsOrderData} = store.getters;
		const productSelectionsToRemove = groupOrderFriendsOrderData.filter(x => x.id === orderItemIdToRemove).map(x => x.productSelections).flat();
		GroupOrderProvider.removeFriendOrder(
			applicationUserIdpToken,
			groupOrderId,
			orderItemIdToRemove,
			appConfig.tenantId,
			store
		).then((res) => {
			store.commit(mutationTypes.UPDATE_GROUP_ORDER_FRIENDS_ORDERS, res.orderItems);
			store.commit(mutationTypes.REMOVE_FROM_CART_BULK, {productSelections: productSelectionsToRemove});
		});
	},
	updateOrderId: async function(orderId) {
		const {applicationUserIdpToken, groupOrderId} = store.getters;
		GroupOrderProvider.updateOrderId(
			applicationUserIdpToken,
			groupOrderId,
			appConfig.tenantId,
			orderId,
			store
		).then(() => {
			store.commit(mutationTypes.RESET_GROUP_ORDER_STATE);
		});
	},
	showSunsetShare: function() {
		const {envPrefix, isSunsetPointsMember, featureToggles} = store.getters;
		if (!featureToggles.sunsetShare || !isSunsetPointsMember) {
			return false;
		}
		
		if (envPrefix === "p") {
			return appConfig.channelAlias() === "mobileApp";
		} else {
			return ["mobileApp", "mobileBrowser"].includes(appConfig.channelAlias());
		}
	},
	isUserGroupOrderOwner: function() {
		const {isUserGroupOrderOwner} = store.getters;
		return isUserGroupOrderOwner;
	}
};

async function updateOrderLines() {
	// update group order friends data
	const {selections, applicationUserIdpToken, groupOrderId} = store.getters;
	const res = await GroupOrderProvider.getOne(
		applicationUserIdpToken,
		groupOrderId,
		appConfig.tenantId,
		store
	);
	store.commit(mutationTypes.UPDATE_GROUP_ORDER_FRIENDS_ORDERS, res.orderItems);

	if (!res.orderItems.length) {
		return;
	}
	// update selections
	const responseProductSelections = res.orderItems.map(item => item.productSelections).flat();
	const storeSelectionIds = selections.map(item => item.productSelectionId);
	const diff = responseProductSelections.filter(item => !storeSelectionIds.includes(item.productSelectionId));
	if (diff.length) {
		store.commit(mutationTypes.ADD_TO_CART_BULK, {productSelections: diff, isGroupOrderSelections: true});
	}
}